<script setup>
import AgeArea from "@/components/main/recordVideo/ageArea.vue";
import RecordVideoMenu from "@/components/main/recordVideo/recordVideoMenu/recordVideoMenu.vue";
import RecordVideoContent from "@/components/main/recordVideo/recordVideoContent/recordVideoContent.vue";
import PagingComponent from "@/components/common/paging/pagingComponent.vue";
import {onBeforeMount, ref} from "vue";
import axios from "@/axios";
import {useAgeStore, useLanguageStore} from "@/pinia";

const ageStore = useAgeStore();
const languageStore = useLanguageStore();
const menu = ref();
const age = ref(ageStore.getRecentAge);
const ages = ref(ageStore.getAges);
const totalPage = ref(0);
const currentPage = ref(1);

// 검색 상태
const searchDate = ref('');
const searchText = ref('');
const searchTrigger = ref(0);

const props = defineProps({
  meetingType :{
    type: String,
    default: 'mt000'
  }
})

const set_age=(a)=>{
  age.value = a;
  currentPage.value = 1;
}
const set_menu=(m)=>{
  menu.value = m;
  currentPage.value = 1;
}
const set_currentPage = (page) => {
  currentPage.value = page;
}

// 검색 실행
const fn_search = () => {
  currentPage.value = 1;
  searchTrigger.value++;
}

// 검색 초기화
const fn_reset = () => {
  searchDate.value = '';
  searchText.value = '';
  currentPage.value = 1;
  searchTrigger.value++;
}

onBeforeMount(()=> {
  menu.value= props.meetingType
})
</script>

<template>
 <div class="recordVideoArea">
   <div>
     <age-area @set_age='set_age' :ages="ages" :menu="menu"></age-area>
   </div>
   <div class="recordMenu">
     <!-- 탭 + 검색 영역 -->
     <div class="menuSearchRow">
       <record-video-menu @set_menu="set_menu" :codeId="menu"></record-video-menu>
       <div class="searchArea">
         <input type="date" v-model="searchDate" class="dateInput" />
         <input
           type="text"
           v-model="searchText"
           :placeholder="languageStore.get('enterMeetingName')"
           class="searchInput"
           @keyup.enter="fn_search"
         />
         <button class="searchBtn" @click="fn_search">
           <v-icon size="20">mdi-magnify</v-icon>
         </button>
         <button class="resetBtn" @click="fn_reset">
           <v-icon size="20">mdi-refresh</v-icon>
         </button>
       </div>
     </div>
     <record-video-content
       :age="age"
       :menu="menu"
       :searchDate="searchDate"
       :searchText="searchText"
       :searchTrigger="searchTrigger"
       :currentPage="currentPage"
       @update:totalPage="(v) => totalPage = v"
     ></record-video-content>
     <div class="pageArea">
       <paging-component
         :totalPage="totalPage"
         :page="currentPage"
         @set_currentPage="set_currentPage"
       ></paging-component>
     </div>
   </div>
 </div>
</template>

<style scoped>
 .recordVideoArea{
   display: flex;
   background: white;
   width: 100%;
   height: 80vh;
   justify-content: flex-start;
 }
 .recordMenu{
   margin-left: 1vw;
   display: flex;
   flex-direction: column;
 }
 .pageArea{
   display: flex;
   justify-content: center;
 }

 .menuSearchRow {
   display: flex;
   align-items: center;
   justify-content: space-between;
   width: 66vw;
 }

 .searchArea {
   display: flex;
   align-items: center;
   gap: 8px;
   padding-right: 10px;
   height: 100%;
   border-bottom: 1px solid #C7C7C7;
 }

 .dateInput {
   padding: 6px 10px;
   border: 1px solid #dee2e6;
   border-radius: 4px;
   font-size: 14px;
   height: 36px;
   width: 140px;
 }

 .searchInput {
   padding: 6px 10px;
   border: 1px solid #dee2e6;
   border-radius: 4px;
   font-size: 14px;
   height: 36px;
   width: 180px;
 }

 .searchInput::placeholder {
   color: #adb5bd;
 }

 .searchBtn {
   width: 36px;
   height: 36px;
   background-color: #052C65;
   color: white;
   border: none;
   border-radius: 4px;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
 }

 .searchBtn:hover {
   background-color: #041e4a;
 }

 .resetBtn {
   width: 36px;
   height: 36px;
   background-color: #6c757d;
   color: white;
   border: none;
   border-radius: 4px;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
 }

 .resetBtn:hover {
   background-color: #5a6268;
 }
</style>
